import { render } from "./DeepPerformanceCpuPerformance.vue?vue&type=template&id=3dc31d46&scoped=true&ts=true"
import script from "./DeepPerformanceCpuPerformance.vue?vue&type=script&lang=ts"
export * from "./DeepPerformanceCpuPerformance.vue?vue&type=script&lang=ts"

import "./DeepPerformanceCpuPerformance.vue?vue&type=style&index=0&id=3dc31d46&scoped=true&lang=css"
import "./DeepPerformanceCpuPerformance.vue?vue&type=style&index=1&id=3dc31d46&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc31d46"]])

export default __exports__